import _format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import isValid from 'date-fns/isValid'
// veja o que ocorre em datas no ano 0020 com o parseISO original
import ptBR from 'date-fns/locale/pt-BR'
import enUS from 'date-fns/locale/en-US'
import es from 'date-fns/locale/es'
import defaultLang from './default-lang'

const LOCALES = {
    'pt-BR': ptBR,
    en: enUS,
    'en-US': enUS,
    es: es,
}

const hasTimezoneOffset = (s) => s && s.substring(10).match(/Z|\+|-/) != null

function formatDate(date: string | Date, locale: string = defaultLang(), format?: string): string {
    if (date == null) return ''
    const _locale = (locale && (LOCALES[locale] || LOCALES[locale.substring(0, 2)])) || ptBR
    if (typeof date === 'string') {
        if (date.length > 10 && !hasTimezoneOffset(date)) {
            date = date + 'Z'
        }
        const parsedDate = parseISO(date)
        if(!isValid(parsedDate)) {
            return date
        } else if (date.length === 10) {            
            return _format(parsedDate, format || 'P', { locale: _locale })
        } else {
            return _format(parsedDate, format || 'P p', { locale: _locale })
        }
    } else if (isValid(date)) {
        return _format(date, format || 'P', { locale: _locale })
    }
    return ''
}

export default formatDate

export const toISODate = (date: Date | string): string => {
    if (typeof date === 'string') {
        return _format(parseISO(date), 'yyyy-MM-dd')
    } else if (isValid(date)) {
        return _format(date, 'yyyy-MM-dd')
    }
}
